function FormAppoiment({ image1 }) {
    return (
        <section className="w-full flex justify-center items-center py-10 bgimgclean">
            <div className="z-10 w-full flex md:flex-row flex-col justify-center items-center h-auto space-y-5">
                <div className="md:w-1/2 w-full flex justify-center items-center">
                    <img
                        className="w-[80%] h-auto rounded-tr-[20%] rounded-bl-[20%]"
                        src={image1}
                        alt="image1"
                    />
                </div>

                <div className="md:w-1/2 w-[90%] flex md:px-10 px-0">
                    <div className="elfsight-app-8c4dcbfe-b31e-46c1-a07e-cdd3ad1c437e" data-elfsight-app-lazy></div>
                </div>
            </div>
        </section>
    );
}


export default FormAppoiment;